import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { StorageService } from '../storage.service';

export type AmbienteBanco = 'Desenvolvimento' | 'Homologacao' | 'Producao';

const STORAGE_KEY = 'ambienteBanco';

@Injectable({
  providedIn: 'root'
})
export class AmbienteLoginService {
  readonly permitirTrocaAmbiente = this.resolverPermiteTroca();

  readonly opcoes: { valor: AmbienteBanco; rotulo: string }[] = [
    { valor: 'Desenvolvimento', rotulo: 'Desenvolvimento' },
    { valor: 'Homologacao', rotulo: 'Homologação' },
    { valor: 'Producao', rotulo: 'Produção' },
  ];

  private ambienteAtual: AmbienteBanco;

  constructor(private storage: StorageService) {
    this.ambienteAtual = this.carregar();
  }

  get ambiente(): AmbienteBanco {
    return this.ambienteAtual;
  }

  definir(ambiente: AmbienteBanco): void {
    this.ambienteAtual = this.normalizar(ambiente);
    this.storage.setLocalItem(STORAGE_KEY, this.ambienteAtual);
  }

  private carregar(): AmbienteBanco {
    const padrao = this.padraoDoBuild();
    const localhostApis = /localhost|127\.0\.0\.1/i.test(this.urlsDoBuild());
    const salvo = this.storage.getLocalItem(STORAGE_KEY);

    // APIs locais + padrão Dev: evita ficar preso em Homologação gravada no login antigo.
    if (localhostApis && padrao === 'Desenvolvimento' && salvo === 'Homologacao') {
      this.definir('Desenvolvimento');
      return 'Desenvolvimento';
    }

    if (salvo) {
      return this.normalizar(salvo);
    }
    return padrao;
  }

  private normalizar(valor?: string): AmbienteBanco {
    const texto = (valor || '').trim();
    if (texto === 'Homologacao' || texto.toLowerCase() === 'homologacao' || texto === 'Homologação') {
      return 'Homologacao';
    }
    if (texto === 'Desenvolvimento' || texto.toLowerCase() === 'desenvolvimento') {
      return 'Desenvolvimento';
    }
    if (texto === 'Producao' || texto.toLowerCase() === 'producao' || texto === 'Produção') {
      return 'Producao';
    }
    return this.padraoDoBuild();
  }

  private padraoDoBuild(): AmbienteBanco {
    const alvo = this.urlsDoBuild();
    if (/localhost|127\.0\.0\.1/i.test(alvo)) {
      return 'Desenvolvimento';
    }
    if (environment.ambientePadrao === 'Homologacao') {
      return 'Homologacao';
    }
    if (environment.ambientePadrao === 'Producao') {
      return 'Producao';
    }
    if (environment.ambientePadrao === 'Desenvolvimento') {
      return 'Desenvolvimento';
    }
    if (/homologacao/i.test(alvo)) {
      return 'Homologacao';
    }
    return 'Desenvolvimento';
  }

  private resolverPermiteTroca(): boolean {
    const alvo = this.urlsDoBuild();
    if (/localhost/i.test(alvo) || /homologacao/i.test(alvo)) {
      return true;
    }
    return environment.permitirTrocaAmbiente === true;
  }

  private urlsDoBuild(): string {
    return [
      environment.apiUrl,
      environment.apiOperacionalUrl,
      environment.apiExecutivoUrl,
      environment.siteUrl,
    ].filter(Boolean).join(' ');
  }
}
